import {decorate, inject, injectable} from '@yosmanyga/di';
import {action, observable, runInAction} from 'mobx';
import type {HelpType} from '../data';
import {HelpApi} from '../data';

class HelpController {
    @observable accessor texts!: HelpType;

    @observable accessor loaded: boolean;

    constructor(private helpApi: HelpApi) {
        this.loaded = false;
    }

    @action load = async () => {
        const texts = await this.helpApi.get();

        runInAction(() => {
            this.texts = texts;
            this.loaded = true;
        });
    };
}

decorate(injectable(), HelpController);
decorate(inject(HelpApi), HelpController, 0);

export {HelpController};
